import http from '@/libs/AxiosPlugin'

const productionPlan = {
  list () {
    return http.get('/productionPlan/list')
  },

  delete (id) {
    return http.post('/productionPlan/delete', {id})
  },

  save (p) {
    return http.post('/productionPlan/save', p)
    // return Promise.resolve({ id: r.id, name: 'admin', permissions: [{action: 'system', value: 1}, {action: 'people', value: 2}] })
  },
  close (id) {
    return http.post('/collectorPlan/close', {id})
  }
}

export default productionPlan



// WEBPACK FOOTER //
// ./src/api/productionPlan.js